import Swiper, { Navigation } from 'swiper';
import { swiperObserver } from '../utils/swiper.utils.js';

let governmentSwiperWr = document.querySelectorAll('.government-swiper-wr');

governmentSwiperWr.forEach((el, idx) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let slides = el.querySelectorAll('.swiper-slide');

    let activeSlideIndex = 0;

    if(slides.length) {
      for (let i = 0; i < slides.length; i++) {
        if(slides[i].classList.contains('active')) {
          activeSlideIndex = i;
        }
      }
    }

    const tabs = el.querySelectorAll('.vertical-accordion__tab');
    const contentItems = document.querySelectorAll('.vertical-accordion__item');

    let swiper = new Swiper(swiperEl, {
      modules: [Navigation],
      observer: true,
      observeParents: true,
      spaceBetween: 24,
      slidesPerView: 1,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      // initialSlide: activeSlideIndex,
      breakpoints: {
        320: {
          slidesPerView: 1,
        },
        768: {
          spaceBetween: 24,
          slidesPerView: 2,
        },
        1024: {
          spaceBetween: 34,
          slidesPerView: 3,
        },
      },
      on: {
        slideChange: function () {
          tabs.forEach(t => t.classList.remove('active'));
          contentItems.forEach(c => c.classList.remove('active'));

          const activeIndex = this.activeIndex;
          if (tabs[activeIndex]) tabs[activeIndex].classList.add('active');
          if (contentItems[activeIndex]) contentItems[activeIndex].classList.add('active');
        }
      }
    });


    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        tabs.forEach(t => t.classList.remove('active'));
        contentItems.forEach(i => i.classList.remove('active'));

        tab.classList.add('active');
        contentItems[index].classList.add('active');

        swiper.slideTo(index, 300);
      });
    });

    function syncTabWithSlide() {
      const activeSectorIndex = getActiveSectorIndexFromUrl();
      if (activeSectorIndex !== null && tabs[activeSectorIndex]) {
        tabs.forEach(t => t.classList.remove('active'));
        contentItems.forEach(c => c.classList.remove('active'));

        tabs[activeSectorIndex].classList.add('active');
        contentItems[activeSectorIndex].classList.add('active');

        swiper.slideTo(activeSectorIndex, 0);
      }
    }

    function getActiveSectorIndexFromUrl() {
      const params = new URLSearchParams(window.location.search);
      const sectorId = params.get('sector');
      if (sectorId) {
        return parseInt(sectorId) - 1;
      }
      return null;
    }

    syncTabWithSlide();
  }
});
